












































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { store } from "../../store/mainStore";
import Introducao from "./Introducao.vue";
import DadosPessoais from "./DadosPessoais.vue";
import Finalidade from "./Finalidade.vue";
import ControlesPrivacidade from "./ControlesPrivacidade.vue";
import CompartilhamentoInformacoes from "./CompartilhamentoInformacoes.vue";
import PoliticaCookies from "./PoliticaCookies.vue";
import SobrePolitica from "./SobrePolitica.vue";

@Component({
  components: {
    Introducao,
    DadosPessoais,
    Finalidade,
    ControlesPrivacidade,
    CompartilhamentoInformacoes,
    PoliticaCookies,
    SobrePolitica,
  },
})
export default class PoliticaPrivacidade extends Vue {}
